export const SET_SITE_DATA = "SET_SITE_DATA";
export const SET_PAGE = "SET_PAGE";
export const SET_USER_DATA = "SET_USER_DATA";
export const SET_LOADING = "SET_LOADING";
export const SET_HOMEPAGE_DATA = "SET_HOMEPAGE_DATA";
export const SET_CART_DATA = "SET_CART_DATA";
export const SET_COUPON_DATA = "SET_COUPON_DATA";
export const SET_SEARCH_TEXT = "SET_SEARCH_TEXT";
;

